import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type WishlistMenuButtonProps = {
    handleClick: () => void;
};

const WishlistMenuButton = ({ handleClick }: WishlistMenuButtonProps) => {
    const { t } = useGranite();

    return (
        <a
            href="#"
            onClick={(e) => {
                e.preventDefault();
                handleClick();
            }}
        >
            <i className={"las la-angle-left"} />
            {t("wishlistMenuButton.link.myLists")}
        </a>
    );
};

export default WishlistMenuButton;
